<script setup>
import { ORGANISATION_NAME, ORGANISATION_URL } from '@/constants/schema-org';

definePageMeta({
  layout: 'seo',
});

const { pageData, pageError } = await usePageSeoMeta({
  keepLocale: true,
  withTimetableHandling: true,
});
await useHandlePageSeoMeta({
  pageData,
  pageError,

  withErrorHandling: true,
  sectionsMustExist: true,
});

// schema-org
const route = useRoute();
const { locale } = useI18n();

const headerData = computed(() =>
  pageData.value.sections
    ? pageData.value.sections.find((section) => section.type === 'header')
    : {},
);

const primaryImageUrl = computed(() => {
  if (!headerData.value?.data?.background) return;

  if (headerData.value.data.background.startsWith('/'))
    return `${ORGANISATION_URL}${headerData.value.data.background}`;
  else return headerData.value.data.background;
});

useSchemaOrg([
  defineWebPage({
    '@id': ORGANISATION_URL + route.fullPath + '#webpage',
    name: pageData.value.meta?.title,
    url: ORGANISATION_URL + route.fullPath,
    breadcrumb: {
      '@id': ORGANISATION_URL + route.fullPath + '#breadcrumb',
      url: ORGANISATION_URL + route.fullPath,
    },
    mainEntity: [
      {
        '@type': 'Trip',
        name: pageData.value.meta?.title,
        offers: {
          '@type': 'Offer',
          url: ORGANISATION_URL + route.fullPath,
          availability: 'https://schema.org/InStock',
        },
        provider: {
          '@type': 'Organization',
          name: ORGANISATION_NAME,
          url: ORGANISATION_URL,
        },
      },
    ],
    potentialAction: [],
    primaryImageOfPage: {
      '@type': 'ImageObject',
      url: primaryImageUrl.value,
      contentUrl: primaryImageUrl.value,
      caption: headerData.value?.data?.title,
      inLanguage: locale.value,
    },
    description: pageData.value.meta?.description,
    publisher: {
      '@type': 'Organization',
      name: ORGANISATION_NAME,
      url: ORGANISATION_URL,
    },
  }),
]);
</script>

<template>
  <BundlesSeo v-if="pageData?.sections" :sections="pageData.sections" />
</template>
